module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAYCAMAAADeQm2wAAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAIZeKed2nXfC2oQmCTi4P+Ongk4dyRzn2xsO3r3pjGwxdK8cCAAAAjUlEQVQoz6XQyQ7CMAxF0RgwGUoThtIyw/v/n8SLLp8RUu8imyPZScLvWkkgpdIMC5yKYUIUUkQyBCSQBPgbZexcrBccew/PsO7CcYN8Ava7juM21BtsNkc74wEYKc6rnw7WK6Bvim2+EUO1fVnoU14AtHc+4fNQm0iQtBQVeU3KUMMIpxisaViRhimEL09HGlChwvNuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/live_preview.png
// module id = 4H5W
// module chunks = 2 3 4 6 7 8 9